import { RootState } from '../../../applicationStore';
import { TimesheetState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getTimesheetState = (state: RootState): TimesheetState =>
  state.timesheet;

export const getTimesheetLoader = createSelector(
  getTimesheetState,
  (state): boolean => state.loading,
);

export const getTimesheetData = createSelector(
  getTimesheetState,
  (state): TimesheetState['data'] | null => state?.data || null,
);
